// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export{black:#000;white:#fff;red:#c90015}", "",{"version":3,"sources":["/home/webapp/django-projects/art-attack/frontend/src/css/colors.scss"],"names":[],"mappings":"AAKA,QACI,UANI,CAOJ,UANI,CAOJ,WANE","file":"colors.scss","sourcesContent":["$black: #000;\n$white: #FFF;\n$red: #C90015;\n\n// Export for use in React components\n:export {\n    black: $black;\n    white: $white;\n    red: $red;\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
